import { IPurchaseDataDto } from '@pressreader/commerce-api/legacy';

import { IEcommerceData } from '../models/models';

import { mapPurchaseItemDataDto } from './mapPurchaseItemDataDto';

function mapPurchaseDataDto(dto: IPurchaseDataDto): IEcommerceData {
    return {
        affiliation: dto.affiliation,
        cardType: dto.cardType,
        currency: dto.currency,
        items: dto.items.map(mapPurchaseItemDataDto),
        tax: dto.tax,
        transactionId: dto.transactionId,
        value: dto.value,
    };
}

export { mapPurchaseDataDto };
